// project imports
import AuthGuard from "shared/utils/route-guard/AuthGuard";
import MinimalLayout from "layout/MinimalLayout";
import NavMotion from "layout/NavMotion";
import Loadable from "shared/ui/Loadable";
import lazyWithLogout from "shared/utils/lazyWithLogout";

// login routing
const AuthLogin = Loadable(
  lazyWithLogout(() => import("features/authentication/components/Login")),
);

const LoginRoutes = {
  path: "/",
  element: (
    <NavMotion>
      <AuthGuard>
        <MinimalLayout />
      </AuthGuard>
    </NavMotion>
  ),
  children: [
    {
      path: "/",
      element: <AuthLogin />,
    },
  ],
};

export default LoginRoutes;
